module.exports = __webpack_public_path__ + "img/katan_yes.8c93f02d.png";